var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserstatusicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.89,
    height: 22.147,
    viewBox: "0 0 28.89 22.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User_status_icon",
    "data-name": "User status icon",
    d: "M456.168,484.477l-3.435,3.455-3.435-3.455-6.87-6.91,3.435-3.455,6.87,6.91,13.74-13.819,3.435,3.455Z",
    transform: "translate(-441.724 -466.494)",
    fill: "#3c3c3b",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserstatusicon);
export default __webpack_public_path__ + "static/media/User status icon.f5b6a41bee1c6f7801409340b49c635b.svg";
export { ForwardRef as ReactComponent };